import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import constants from '../../../constants';
import { Creators as procedureActions } from '../../../../../../domain/useCases/procedures/getProcedureInformation';
import ViewInfo from './views/Info';
import useTitle from '@/presentation/hooks/useTitle';
import ErrorProcess from './dialogs/ErrorProcess';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import routes from '@/presentation/components/Routes/routingMap';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';

const CertificateOfStudiesInfoViewController = ({
  history
}: RouteComponentProps) => {
  const dispatch = useDispatch();

  const [showModalCancelProcedure, setShowModalCancelProcedure] =
    useState(false);

  const {
    procedure: procedureSelected,
    isLoading: isLoadingProcedure,
    selectedProcedureId,
    error: procedureError
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  const handlerBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!procedureSelected && !isLoadingProcedure) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.certificateOfStudies
        )
      );
    }
  }, []);
  if (
    selectedProcedureId !== undefined &&
    procedureWhiteList?.length > 1 &&
    !procedureWhiteList?.includes(selectedProcedureId?.toString())
  ) {
    history.push(routes.student.procedures.home);
  }

  useTitle('Certificado de estudios');
  return (
    <>
      <ModuleContainer
        containerType="subsection"
        data-testid="cmp-CertificateOfStudiesInfoViewController"
      >
        <SubsectionHeader
          title="Certificado de estudios"
          onClick={handlerBack}
        />
        <ViewInfo
          data={procedureSelected}
          isLoading={isLoadingProcedure}
          hasError={procedureError}
        />
      </ModuleContainer>
      <ErrorProcess
        show={showModalCancelProcedure}
        handlerClose={() => setShowModalCancelProcedure(false)}
      />
    </>
  );
};

export default CertificateOfStudiesInfoViewController;
